import { getAllRooms } from '@/app/services/rooms/rooms';
import * as Actions from '@/app/store/actions';
import FilterIcon from '@shared/icons/FilterIcon';
import { Divider } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PopoverCombobox from '@shared/Reports/PopoverCombobox';
import PopoverSelect from '@shared/Reports/PopoverSelect';

const RoyaltyFiltersBar = ({ filters, setFilters }) => {
	const [rooms, setRooms] = useState([]);
	const [roomsLoading, setRoomsLoading] = useState(true);
	const dispatch = useDispatch();

	const now = new Date();
	const currentYear = now.getFullYear();
	const selectedYear = filters.year || currentYear;
	const currentQuarter = Math.floor(now.getMonth() / 3) + 1;
	// If we're showing the current year, limit to the current quarter
	const maxQuarter = selectedYear.value === currentYear ? currentQuarter : 4;

	useEffect(() => {
		const fetchRooms = async () => {
			try {
				setRoomsLoading(true);
				const res = await getAllRooms();
				setRooms(res.data);
				setRoomsLoading(false);
			} catch (error) {
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch rooms',
						variant: 'error',
					})
				);
				setRoomsLoading(false);
			}
		};
		fetchRooms();
	}, []);

	const handleQuarterAndYearChange = (filters) => {
		// If switching to current year and selected quarter is beyond current quarter
		let adjustedQuarter = filters.quarter?.value;
		if (filters.year?.value === currentYear && adjustedQuarter > currentQuarter) {
			adjustedQuarter = currentQuarter;
		}

		setFilters((prev) => ({
			...prev,
			...filters,
			quarter: { label: `Q${adjustedQuarter}`, value: adjustedQuarter },
			year: { label: filters.year?.value.toString(), value: filters.year?.value },
		}));
	};

	return (
		<div className="text-white py-16 px-32 justify-between flex" style={{ background: 'rgb(0, 46,108)' }}>
			<span className="flex items-center gap-8 text-16">
				<FilterIcon /> Filter:
			</span>
			<div className="flex gap-8 md:gap-16">
				<PopoverCombobox
					currentFilter="room_id"
					filters={filters}
					options={
						roomsLoading
							? []
							: rooms?.map((room) => {
									return { label: room?.name, value: room?.id };
								})
					}
					setFilter={setFilters}
					title="Room"
				/>
				<Divider className="bg-white" flexItem orientation="vertical" />
				<PopoverSelect
					currentFilter="year"
					filters={filters}
					options={(() => {
						const currentYear = new Date().getFullYear();
						const years = [];
						for (let y = currentYear; y >= Math.max(2000, currentYear - 4); y -= 1) {
							years.push({ label: `${y}`, value: y });
						}
						return years;
					})()}
					setFilter={handleQuarterAndYearChange}
					title="Year"
				/>
				<Divider className="bg-white" flexItem orientation="vertical" />
				<PopoverSelect
					currentFilter="quarter"
					filters={filters}
					options={(() => {
						return Array.from({ length: maxQuarter }, (_, i) => ({
							label: `Q${i + 1}`,
							value: i + 1,
						}));
					})()}
					setFilter={handleQuarterAndYearChange}
					title="Quarter"
				/>
			</div>
		</div>
	);
};

export default RoyaltyFiltersBar;
